<template>
    <section class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-row flex-wrap w-full pb-4 sm:pb-8">
                <div
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in filteredMenu" :key="index" :item="item"></tile>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Tile from "../../components/shared/Tile.vue";
export default {
    name: "international-recognition-index",
    components: {
        Tile,
    },
    data() {
        return {
            menu: [
                {
                    id: 1,
                    isActive: true,
                    isImage: true,
                    path: "/international-recognition/international-accreditation",
                    title: "International Accreditation",
                    icon: ``,
                    image: require('../../assets/images/icons/img1.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    role: ['superadmin', 'admin', 'Facility', 'Viewer'],
                    permission: "",
                },
                {
                    id: 1,
                    isActive: true,
                    isImage: true,
                    path: "/international-recognition/professional-certification",
                    title: "Professional Certifications",
                    icon: ``,
                    image: require('../../assets/images/icons/img2.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    role: ['superadmin', 'admin', 'Facility', 'Viewer'],
                    permission: "",
                },
            ],
        };
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        filteredMenu() {
            return this.menu.filter(item => {
                const hasRole = item.role.includes(this.role);

                const hasPermission =
                    this.role === 'superadmin' || // Superadmin bypass
                    !item.permission ||           // No permission key? Skip check
                    this.permissions.includes(item.permission); // Normal check

                return hasRole && hasPermission;
            });
        },
    },
}
</script>